import HelpIcon from "@material-ui/icons/Help";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import InputAdornment from "@mui/material/InputAdornment";
import Tab from "@mui/material/Tab";
import TextField from "@mui/material/TextField";
import React from "react";

function TextFieldI18N(props) {
  const {
    id,
    type,
    value,
    error,
    name,
    label,
    placeholder,
    className,
    autoFocus,
    inputProps,
    multiline,
    onChange,
    onLeave,
    size,
    disabled,
    langList,
    isMultilang,
    hint,
  } = props;

  const [tabIndex, setTabIndex] = React.useState(0);

  function handleChange(e) {
    onChange(e, langList[tabIndex]);
  }

  function SimpleDialog(props) {
    const { onClose, hint, open } = props;

    const handleClose = () => {
      onClose();
    };

    return (
      <Dialog onClose={handleClose} open={open}>
        <DialogTitle>{hint}</DialogTitle>
      </Dialog>
    );
  }

  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = (value) => {
    setOpen(false);
  };

  return (
    <Box sx={{ width: "100%", typography: "body1" }}>
      {isMultilang && (
        <TabContext value={tabIndex}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <TabList
              onChange={(e, val) => setTabIndex(val)}
              aria-label="lab API tabs example"
            >
              {langList.map((item, index) => (
                <Tab label={item} value={index} />
              ))}
            </TabList>
          </Box>
        </TabContext>
      )}
      <TextField
        InputProps={{
          endAdornment: (
            <InputAdornment position="start">
              {hint && <HelpIcon onClick={handleClickOpen} />}
            </InputAdornment>
          ),
        }}
        disabled={disabled}
        autoComplete="off"
        autoFocus={autoFocus}
        multiline={multiline}
        margin="dense"
        placeholder={label}
        id="desc"
        name={name}
        label={label}
        fullWidth
        variant="standard"
        value={isMultilang ? value[langList[tabIndex]] : value}
        onChange={handleChange}
      />
      <SimpleDialog
        open={open}
        onClose={handleClose}
        hint={hint ?? "hint text"}
      />
    </Box>
  );
}

export default TextFieldI18N;
